/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, computed, createVNode } from 'vue';
import { usePrefixClass } from '../hooks/useConfig.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

var FakeArrow = defineComponent({
  name: "TFakeArrow",
  props: {
    isActive: {
      type: Boolean
    },
    overlayClassName: {
      type: [String, Object, Array]
    },
    overlayStyle: {
      type: Object || String
    }
  },
  setup: function setup(props) {
    var COMPONENT_NAME = usePrefixClass("fake-arrow");
    var classes = computed(function () {
      return [COMPONENT_NAME.value, _defineProperty({}, "".concat(COMPONENT_NAME.value, "--active"), props.isActive), props.overlayClassName];
    });
    return {
      classes: classes
    };
  },
  render: function render() {
    return createVNode("svg", {
      "class": this.classes,
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "style": this.overlayStyle
    }, [createVNode("path", {
      "d": "M3.75 5.7998L7.99274 10.0425L12.2361 5.79921",
      "stroke": "black",
      "stroke-opacity": "0.9",
      "stroke-width": "1.3"
    }, null)]);
  }
});

export { FakeArrow as default };
//# sourceMappingURL=fake-arrow.mjs.map
